import React, { Fragment, useState } from "react";
import {connect} from "react-redux";

import SvgIcon from "@mui/material/SvgIcon";

import LoadingSpinner from "../../ui/loadingSpinner";
import {GroheDownloadIcon} from "../../common/icons";


const UiPopupAIContentResult = (props) => {

  const {aiLoading, aiResults} = props;

  function openBase64InNewTab(data, mimeType) {
    var byteCharacters = atob(data);
    var byteNumbers = new Array(byteCharacters.length);

    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    var file = new Blob([byteArray], {
      type: mimeType + ";base64",
    });

    var fileURL = URL.createObjectURL(file);

    window.open(fileURL, "_blank");

    URL.revokeObjectURL(fileURL);
  }

  const [copied, setCopied] = useState(false);
  const baseButtonStyle = {
    marginBottom: "0.5rem",
    padding: "0.25rem 0.5rem",
    fontSize: "0.875rem",
    borderRadius: "0.25rem",
    transition: "all 0.3s ease-in-out",
  };

  const notCopiedStyle = {
    backgroundColor: "#e5e7eb",
    color: "#374151",
  };

  const copiedStyle = {
    backgroundColor: "#22c55e",
    color: "#ffffff",
  };
  const handleCopy = async (e) => {
    const div = e.currentTarget.nextElementSibling; // the div right after button
    if (div) {
      try {
        await navigator.clipboard.writeText(div.innerText);
        setCopied(true);

        // revert after 3 seconds
        setTimeout(() => setCopied(false), 3000);
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    }
  };

  return (
    <div className="mb-1">
      {aiLoading ? <LoadingSpinner size=" message-loading-left-panel-spinner message-loading-left-panel-spinner--30 h-2 w-2"/> : null}
      {aiResults.map(aiResult => {
        if (!aiResult.resultImageUrl) {
          return null;
        }
        return (
          <div key={aiResult.resultImageUrl}>
                  <button
                    onClick={(e) => e.target.parent.innerTexthandleCopy}
                    className={`
                      absolute top-2 right-2 px-2 py-1 text-sm rounded-md shadow-md 
                      transition-all duration-300 ease-in-out
                      ${copied ? "bg-green-500 text-white" : "bg-gray-200 text-gray-700"}
                      opacity-0 group-hover:opacity-100
                    `}
                  >
                    {copied ? "Copied to Clipboard..." : "Copy"}
                  </button>
            {aiResult.resultImageUrl ?
              <div className="mb-05">
                <a className="link link--blue flex--center" style={{display: "inline-flex", borderBottom: "1px dashed"}}
                   href={aiResult.resultImageUrl} rel="noopener noreferrer" target="_blank">
                  <SvgIcon>
                    <GroheDownloadIcon/>
                  </SvgIcon>
                  <span className="pl-05">Download Image</span>
                </a>
              </div> : null}
            {aiResult.firstPrompt ? (
              <Fragment>
                <button
                  onClick={handleCopy}
                  style={{ 
                    ...baseButtonStyle, 
                    ...(copied ? copiedStyle : notCopiedStyle) 
                  }}>
                  {copied ? "Copied to Clipboard..." : "Copy"}
                </button>
                <div className="mb-05 text-left">
                  <span className="mb-05 block color-primary bold">First Prompt</span>
                  <p className="secondary">{aiResult.firstPrompt}</p>
                </div>
              </Fragment>
            ) : null}
            {aiResult.secondPrompt ? (
              <Fragment>
                <button
                  onClick={handleCopy}
                  style={{ 
                    ...baseButtonStyle, 
                    ...(copied ? copiedStyle : notCopiedStyle) 
                  }}>
                  {copied ? "Copied to Clipboard..." : "Copy"}
                </button>
                <div className="mb-05 text-left">
                  <span className="mb-05 block color-primary bold">Second Prompt</span>
                  <p className="secondary">{aiResult.secondPrompt}</p>
                </div>
              </Fragment>
            ) : null}
            {aiResult.thirdPrompt ? (
              <Fragment>
                <button
                  onClick={handleCopy}
                  style={{ 
                    ...baseButtonStyle, 
                    ...(copied ? copiedStyle : notCopiedStyle) 
                  }}>
                {copied ? "Copied to Clipboard..." : "Copy"}
              </button>
              <div className="mb-05 text-left">
                <span className="mb-05 block color-primary bold">Third Prompt</span>
                <p className="secondary">{aiResult.thirdPrompt}</p>
              </div>
              </Fragment>
            ) : null}
            {aiResult.orderedFeatureGroupsList ? (
              <Fragment>
                <button
                  onClick={handleCopy}
                  style={{ 
                    ...baseButtonStyle, 
                    ...(copied ? copiedStyle : notCopiedStyle) 
                  }}>
                  {copied ? "Copied to Clipboard..." : "Copy"}
                </button>
                <div className="mb-05 text-left">
                  <span className="mb-05 block color-primary bold">OrderedFeatureGroupsList</span>
                  <p className="secondary" style={{fontFamily: "monospace", whiteSpace: "pre-wrap"}}>{aiResult.orderedFeatureGroupsList}</p>
                </div>
              </Fragment>
            ) : null}
            {aiResult.files ? (
              <div className="mb-05 text-left">
                <span className="mb-05 block color-primary bold">Images Sent to OpenAI</span>
                <p className="secondary">
                  {aiResult.files.map(file => {       
                    var url = file.fileUrl;
                    if(url == undefined || url == null || url.trim().length == 0)
                      url = `data:${file.contentType};base64,${file.content}`;
                    var labelStyle = {
                      marginRight: "20px", 
                      display:"inline-block", 
                      backgroundImage:`url(${url})`, 
                      backgroundPosition: "center", 
                      backgroundSize: "contain", 
                      backgroundRepeat: "no-repeat",
                      textShadow: "0px 0px BLACK, -1px -1px BLACK, -1px 0px BLACK, 0px -1px BLACK, 1px 1px BLACK, 1px 0px BLACK, 0px 1px BLACK",
                      color: "white",
                      height: "150px",
                      width: "150px",
                    };
                    
                    if(file.fileUrl != null && file.fileUrl != '')
                    {
                      return (
                        <a href={file.fileUrl} target="_blank" rel="noopener noreferrer">
                          <label style={labelStyle}>{file.featureGroup}</label>
                        </a>
                      )
                    }
                    else {
                      return (
                        <label style={labelStyle} onClick={() => openBase64InNewTab(file.content, file.contentType)}>{file.fileName}
                        </label>
                      )
                    }
                  })}
                </p>
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiLoading, aiResults} = store.aiState;

  return {
    aiLoading,
    aiResults,
  };
};

export default connect(mapStateToProps)(UiPopupAIContentResult)

